import Solution from "./components/solution"
import { SOLUTIONS } from "./shapes"
import "./style.scss"

function SolutionsModule({ solutions }) {
  return (
    <div className="modules_solutions">
      <div className="solutions-main">
        <div className="solutions">
          {solutions?.map((solution) => (
            <Solution key={solution.id} solution={solution} />
          ))}
        </div>
      </div>
    </div>
  )
}
SolutionsModule.propTypes = {
  solutions: SOLUTIONS.isRequired,
}

export default SolutionsModule
